// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import dataTableStyles from "@vanmeter/App/SharedStyles/MyAccountPages/List/DataTableStyles";
import { vmiLocationProductsTabStyles } from "@vanmeter/Overrides/Components/VmiLocationProductsTab";
import { fontConfig } from "@vanmeter/XDL/constants";
import IconGarbage from "@vanmeter/XDL/Icons/IconGarbage";
import { createLinkIconStyles, xScreen } from "@vanmeter/XDL/Utilities";
import { css } from "styled-components";

vmiLocationProductsTabStyles.noResultsText = {
    ...dataTableStyles.noResultsText,
};

vmiLocationProductsTabStyles.noResultsContainer = {
    css: css`
        margin-top: 12px;
    `,
};

vmiLocationProductsTabStyles.itemsCountText = {
    variant: "h4",
    css: css`
        margin-bottom: 0px;
    `,
};

vmiLocationProductsTabStyles.headerContainer = {
    gap: 0,
    css: css`
        padding: 12px 0;
    `,
};

vmiLocationProductsTabStyles.removeLink = {
    ...createLinkIconStyles({
        icon: IconGarbage,
        sizeVariant: "small",
    }),
};

vmiLocationProductsTabStyles.exportLink = {
    typographyProps: {
        ...fontConfig.smallSingleLine,
    },
    css: css`
        margin-left: 24px;
    `,
};

vmiLocationProductsTabStyles.gridItem = {
    width: 12,
    css: css`
        display: flex;
        gap: 24px;
        align-items: center;
    `,
};

vmiLocationProductsTabStyles.headerRowCheckbox = {
    css: css`
        display: none;
        ${xScreen("lte", "md")} {
            display: inline-flex;
        }
    `,
};

vmiLocationProductsTabStyles.overflowMenuWrapper = {
    css: css`
        margin-left: auto;
    `,
};
